import { Link, Stack, Title } from '@kvdbil/components';
import React from 'react';
import styled from 'styled-components';
import { FeaturedCardRecord } from '~/config/generated/graphql';
import { DatoTitleTag } from '~/App/shared/interfaces/datoCMS';
import { isEmptyDocument } from 'datocms-structured-text-utils';
import StructuredText from '~/App/components/DatoCMS/StructuredText';
import { Color, Size } from '@kvdbil/components/types/Types';
import { Image } from 'react-datocms';
import { useSelector } from 'react-redux';
import { localizationSelector } from '~/App/shared/selectors/localization';
import { resolveTrustedPathOrUrl } from '~/helpers/router';

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: ${({ theme }) => theme.colors.background.light};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  flex: 1;
`;

const StructuredTextWrapper = styled.div`
  margin-top: -0.5rem;
  flex: 1;
`;

const LargeFeaturedCard = ({
  image,
  titleWithText,
  buttons
}: FeaturedCardRecord) => {
  const { domainLocale } = useSelector(localizationSelector);
  const title = titleWithText?.[0]?.title?.[0];
  const text = titleWithText?.[0]?.text;
  const button = buttons?.[0];
  const { path, url } = resolveTrustedPathOrUrl(button?.url, domainLocale);
  return (
    <StyledCard>
      {image?.responsiveImage && (
        <Image
          data={image?.responsiveImage}
          objectFit="cover"
          style={{ height: 252 }}
        />
      )}
      <Content>
        <Title as={(title?.tag ?? 'h3') as DatoTitleTag}>{title?.text}</Title>
        <Stack style={{ height: '100%' }}>
          {!isEmptyDocument(text) && (
            <StructuredTextWrapper>
              <StructuredText data={text} />
            </StructuredTextWrapper>
          )}
          {(path || url) && button?.text && (
            <Link
              isButton
              buttonColor={(button?.color ?? 'secondary') as Color}
              buttonSize={(button?.size ?? 'regular') as Size}
              fullWidth
              text={button.text}
              path={path}
              url={url}
            />
          )}
        </Stack>
      </Content>
    </StyledCard>
  );
};

export default LargeFeaturedCard;
